import { AddTableForm, AddTableSubHeader } from '../AddTableForm';
import { StyledActionsRow } from '../DataModelerCommonUI';
import SearchInput from '../../../../components/Form/SearchInput';
import DataModelerTablesGrid from '../DataModelerTablesGrid';
import { useDataModelerContext } from '../../DataModelerContext';
import { useState } from 'react';
import { useAppSelector } from '../../../../redux/hooks';
import { dataModelerSelectCurrentUiState } from '../../../../redux/selectors/dataModeler';

const DataModelerTables = () => {
  const { isEditMode, numTables } = useDataModelerContext();
  const [searchQuery, setSearchQuery] = useState('');

  const currentOpenTable = useAppSelector(
    dataModelerSelectCurrentUiState,
  )?.expandedTableKey;

  const [addTableFormIsOpen, setAddTableFormIsOpen] = useState(false);
  const openAddTableForm = () => {
    setSearchQuery('');
    setAddTableFormIsOpen(true);
  };
  const closeAddTableForm = () => {
    setSearchQuery('');
    setAddTableFormIsOpen(false);
  };

  return addTableFormIsOpen ? (
    <AddTableForm closeAddTableForm={closeAddTableForm} />
  ) : (
    <>
      {!currentOpenTable && (
        <StyledActionsRow $hasSearch={true}>
          <AddTableSubHeader
            isEditMode={isEditMode}
            numTables={numTables}
            onAddTableClick={openAddTableForm}
          />
          <SearchInput
            placeholder={'Search'}
            value={searchQuery}
            onChange={setSearchQuery}
          />
        </StyledActionsRow>
      )}
      <DataModelerTablesGrid
        searchQuery={searchQuery}
        isEditMode={isEditMode}
      />
    </>
  );
};

export default DataModelerTables;
